module.exports = __webpack_public_path__ + "img/about-values-curiosity.jpg?c5edad4f545db0cca5201496208efd31";